export default __webpack_public_path__ + "static/media/arrow-next.58fc74a6.svg";